import script from "./BVIcompany.vue?vue&type=script&setup=true&lang=js"
export * from "./BVIcompany.vue?vue&type=script&setup=true&lang=js"

import "./BVIcompany.vue?vue&type=style&index=0&id=30156716&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30156716"]])

export default __exports__